import React, { Component } from "react";
import {
    Row,
    Col,
    Button,
    Input,
    Label
} from "reactstrap";
import Geosuggest from "react-geosuggest";

import BusinessAddress from "../../../models/business/address";
import {NotificationManager} from "react-notifications";
import Registry from "../../../Utils/Registry";


class EnterpriseInformationDeliveryForm extends Component{
    constructor(props){
        super(props);

        this.handleInputUpdate = this.handleInputUpdate.bind(this);
        this.toggleNameEdit = this.toggleNameEdit.bind(this);
        this.addAddress = this.addAddress.bind(this);
        this.addressChoosen = this.addressChoosen.bind(this);

        this.state = {
            loading: false,
            address_field: "",
            address_name: "",
            edit_name: false,
            valid_address: false
        };

        this.api = Registry.registered("api");
    }

    handleInputUpdate(e, key){
        let s = this.state;
        if(s.hasOwnProperty(key))
            s[key] = e.target.value;
        this.setState(s);
    }

    toggleNameEdit(){
        this.setState({
            address_name: "",
            edit_name: !this.state.edit_name
        });
    }

    addressChoosen(address){
        this.setState({
            address_field: address.description
        }, () => { this.checkAdress() });
    }

    addAddress(){
        this.setState({loading: true});

        if(this.state.address_field){
            let address = new BusinessAddress({
                location: this.state.address_field,
                name: this.state.address_name
            });

            address.save(() => {
                this.setState({loading: false}, () => {
                    NotificationManager.success("Adresse ajoutée")
                });
                this.props.onAddressAdded();
            }, () => {
                this.setState({loading: false}, () => {
                    NotificationManager.error("Impossible d'ajouter l'adresse");
                });
            });
        }
        else{
            this.setState({loading: false}, () => {
                let msg = !this.state.valid_address ? "Cette adresse n'est pas dans la zone de livraison" : "Merci de saisir une adresse valide";
                NotificationManager.error(msg);
            });
        }
    }

    checkAdress = () => {
        this.api.get("/orders/checkZone?address=" + this.state.address_field + "&is_business=1")
            .then(() => {
                this.setState({valid_address: true});
            })
            .catch(() => {
                this.setState({valid_address: false, address_field: ""});
            })
    };

    render(){
        return (
            <div>
                <Row>
                    <Col md="12">
                        <Label>
                            Adresse de livraison
                        </Label>

                        <Geosuggest
                            country="fr"
                            onSuggestSelect={this.addressChoosen}
                            placeholder="Ex: 7 rue de Paris, 75001 ..."
                        />
                    </Col>
                </Row>

                <Row className="marg-t-15 marg-b-15">
                    <Col lg="12" xs="12">
                        <Label className="bold form-control-label">D&eacute;signation</Label>
                        <Input type="text" placeholder="Exemple: Bureaux" className="wp-100" value={this.state.address_name} onChange={e => {this.handleInputUpdate(e, "address_name")}} required />
                    </Col>
                </Row>

                <Row className="marg-t-20">
                    <Col md="12" className="center">
                        <Button color="primary" className="text-uppercase" onClick={this.addAddress}>
                            {
                                this.state.loading ?
                                    <i className="icon icon-loading animated spin infinite f-18"> </i>
                                    :
                                    "Ajouter"
                            }
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

EnterpriseInformationDeliveryForm.defaultProps = {
    onAddressAdded: () => {}
};

export default EnterpriseInformationDeliveryForm;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Information/DeliveryForm.js